











import { Component, Vue, Prop } from 'vue-property-decorator';
import moment from 'moment';
import _ from 'lodash'
import VideoContainer from './VideoContainer.vue'
import { queryLiveRoomPlaybDataByRoomId } from 'apiUtils/ZnPlayer'
import { statCodeEnum } from '@/common/enums'
import { initRequestAnimationFrame, isIOS } from 'utils/index'
import { MD5 } from '@/sdk/lib'

const VOICE_LIVE_TYPE = 1;
const NO_AUTH_ACCESS = -32;
const LIVE_ROOM_DELETE = -22;
interface IReplay {
  src: string;
  /** 视频总时长 */
  duration: number;
  /** 相对于总时间的开始时间 */
  offset?: number;
  startTime: string;
  endTime: string;
  playing: boolean;
  videoType?: string;
  isMainWindow?: boolean;
}

@Component({
  components: {
    VideoContainer
  },
})
export default class ZnPlayer extends Vue {
  @Prop({
    type: String,
    required: true,
    default: '',
  }) private roomId!: string;

  @Prop({
    type: String,
    required: true
  }) private sid!: string;

  @Prop({
    type: String,
    required: true,
    default: ''
  }) private userId!: string;

  @Prop({
    type: Boolean,
    default: false
  }) private showControls!: boolean;

   @Prop({
    type: Boolean,
    default: false
  }) private isVideoContain!: boolean;

  private anchor = ''
  private anchorIds: any[] = []
  private playPath: any[] = []
  private rePlayMain: IReplay[] = []
  private rePlayShare: IReplay[] = []
  private linePlay: IReplay[] = []
  private totalTime = 0
  private videoSource: IReplay[] = []
  private roomPic = ''
  private preDate = Date.now()
  private currentPlayTime = 0
  private isMix = false // 混流 不同于 合成 isMixture

  public beforeCreate () {
    initRequestAnimationFrame()
  }

  public mounted () {
    this.getReplayData()
    this.$store.dispatch('getAuthorDetail')
  }

  private showDiago (msg: string) {
    this.$weui.dialog({
      title: '提示',
      content: msg,
      buttons: [{
          label: '确定',
          type: 'primary',
          onClick: () => {console.log('确定')}
      }]
    })
  }

    // 处理回放地址防盗链后无法解析问题
    private async handlePath(playPath) {
    const newPath: any = []
    for await (let item of playPath) {
      const isInterface = /.do/i.test(item.url)
      if (isInterface) {
        // TODO 是否存在跨域问题
        const res = await fetch(item.url)
        newPath.push({ ...item, url: res.url })
      } else {
        newPath.push(item)
      }
    }
    return newPath
  }

  private async playPathFun (playPath, mixPlayPath) {
    let mixture = false
    if (playPath && playPath.length === 1) {
      const { isMixture } = playPath[0]
      mixture = isMixture === 1
    }
    let targetPath = mixture ? playPath : mixPlayPath.length > 0 ? mixPlayPath : playPath
    targetPath = await this.handlePath(targetPath)
    this.isMix = !mixture && mixPlayPath.length > 0
    this.playPath = targetPath.map(item => ({
      ...item,
      url: item.url.replace('http://', 'http://')
    }))
  }

  private async getReplayData () {
    const  isPreview = this.$route.params.isPreview === '1'
    const res: any = await queryLiveRoomPlaybDataByRoomId(this.roomId, this.sid)
    if (!res.body) {
      this.showDiago(res.message)
      return
    }
    if (res.code === LIVE_ROOM_DELETE) {
      this.showDiago('直播间被删除')
      return;
    }
    if ((res.body.statCode === '2' || res.code === NO_AUTH_ACCESS) && !isPreview) {
      this.showDiago('没有权限进入')
      return;
    }
    if (res.body.statCode === statCodeEnum.ALREADY_COMPLETE || res.body.statCode === statCodeEnum.ALREADY_DELETE) {
      this.showDiago(res.body.statCode === statCodeEnum.ALREADY_DELETE ? '回放已删除' : '回放已结束')
      return;
    }
    if (res.body.feeType === 1 && res.body.isPaid !== 1) {
      this.showDiago('该直播为付分直播，请登录知鸟APP付费后观看')
      return;
    }
    let { playPath, mixPlayPath = [] } = res.body
    // 1224 合成 > 混流 > 普通（主流）
    await this.playPathFun(playPath, mixPlayPath) // 超出最大圈复杂度，抽离
    if (res.body.anchor) {
      this.anchorIds = [res.body.anchor]
    } else {
      this.anchorIds = res.body.anchors.map((item: any) => item.anchorId)
    /*
      *字符串传输按utf-8编码。摄像头数据类型是main，屏幕分享的数据类型是aux。而BIZID是一个固定的参数，可以在直播控制台的顶部找到它。
      *假如BIZID=8888,用户名=14y2l2c，房间号=293710，在进行摄像头分享，则MD5(293710_14y2l2c_main)=81265058829fd2e50c8ec2ac78d55127。那么直播码就是8888_81265058829fd2e50c8ec2ac78d55127。
      */
    }
    this.roomPic = res.body.roomPic
    this.getAchorVideo()
  }

  private getAchorVideo () {
    let mixStream: any[] = []
    let rePlayMain: any[] = []
    let rePlayShare: any[] = []
    let linePlay: any[] = []
    this.anchorIds.forEach((id) => {
      // 回放优先级 mix > main
      // 混流md5码
      const mixMd5 = MD5(`${this.roomId}_mix`)
      // 主视频md5码
      const achorMd5 = MD5(`${this.roomId}_${id}_main`)
      // 分享视频md5码
      const achorAux = MD5(`${this.roomId}_${id}_aux`)
      this.playPath
      .forEach((item: any) => {
        const filemd5 = item.fileName.split('_')[1]
        const fileNameArr = item.fileName.split('_')
        if (filemd5 === mixMd5) {
          mixStream.push(this.formatVideo(item, fileNameArr, 'main'))
        } else if (filemd5 === achorMd5) {
          rePlayMain.push(this.formatVideo(item, fileNameArr, 'main'))
        } else if (filemd5 === achorAux) {
          rePlayShare.push(this.formatVideo(item, fileNameArr, 'share'))
        } else {
          linePlay.push(this.formatVideo(item, fileNameArr, 'line'))
        }
      })
    })
    console.log('mix stream:', mixStream)
    // 如果分拣的流中有混流，就直接用混流代替主播流
    if (mixStream.length > 0) {
      rePlayMain = mixStream.slice()
    }
    if (rePlayMain.length === 0) {
      rePlayMain = rePlayShare.map(item => ({ ...item, videoType: 'main' }))
      rePlayShare = []
    }
    // 数组去重
    rePlayMain = _.uniqBy(rePlayMain, 'src')
    const totalTime = rePlayMain.reduce((total: number, item: any) => {
      return item.duration + total
    }, 0)
    this.rePlayMain = rePlayMain.sort(((a, b) => {
      return moment(a.startTime).diff(moment(b.startTime))
    }))
    this.videoSource = this.rePlayMain.slice(0, 1)
    // 由于x5浏览器限制，暂时只支持播放主视频，已与莫莫确认
    // if (!isIOS()) {
    //    this.rePlayShare = this.addOffset(rePlayShare)
    //   this.linePlay = this.addOffset(linePlay)
    // }
    this.totalTime = totalTime
    this.listenMainVideoPlay()
  }
  private getSelfMainVideoOffset (startTime: string) {
    let total = 0
    this.rePlayMain.some(item => {
      if (moment(startTime).isBefore(moment(item.endTime))) {
        total = total + moment(startTime).diff(moment(item.startTime), 'seconds')
        return true
      }
      total += item.duration
      return false
    })
    return total
  }

  /**
   * desc: 计算相对于总时间应该开始的时间
   */
  private addOffset (arr: IReplay[]) {
    return arr.map(item => {
        item.offset = this.getSelfMainVideoOffset(item.startTime)
      return item
    })
  }

  private formatVideo (item: any, fileNameArr: string[], videoType: string) {
    const startTime = this.formDate(fileNameArr[fileNameArr.length === 3 ? 1 : 2])
    const endTime = this.formDate(fileNameArr[fileNameArr.length === 3 ? 2 : 3])
    return {
      src: item.url,
      played: false,
      duration: item.duration,
      playing: false,
      videoType,
      startTime,
      endTime
    }
  }

  private formDate = (timestr: string) => {
    const strtTimeArr = timestr.split('-')
    return `${strtTimeArr[0]}-${strtTimeArr[1]}-${strtTimeArr[2]} ${strtTimeArr[3]}:${strtTimeArr[4]}:${strtTimeArr[5]}`
  }

  private listenMainVideoPlay () {
    const nowDate = Date.now()
    if (nowDate - this.preDate >= 1000) {
      this.preDate = nowDate
      this.setCurrentPlayTime()
      this.updateReVideo(this.rePlayShare)
      this.updateReVideo(this.linePlay)
    }
    requestAnimationFrame(this.listenMainVideoPlay)
  }

  private setCurrentPlayTime () {
    const videoSourceTmp = this.videoSource.slice()
    const mainVideo: any = document.getElementById((this.videoSource[0] || {}).src || '')
    if (!mainVideo) { return }
    let currentPlayTime = mainVideo.currentTime
    this.rePlayMain.some((item, index) => {
      if (mainVideo.id === item.src) {
        /**
         * 遍历到当前视频的时候，需要检查是否播放完毕，播放完毕需要播放下一个
         */
        if ((index !==  this.rePlayMain.length - 1) && mainVideo.ended) {
          videoSourceTmp.splice(0, 1, this.rePlayMain[index + 1])
          this.videoSource = videoSourceTmp
        }
        return true
      }
      currentPlayTime += item.duration
      return false
    })
    this.currentPlayTime = currentPlayTime
  }

  private get mVideoSource () {
    let videoSourceTmp = this.videoSource
    if (!this.videoSource.some(item => {
      if (item.videoType === 'share') {
        videoSourceTmp = this.videoSource.map(item => ({
          ...item,
          // isMainWindow: item.videoType === 'share'
        }))
        return true
      }
      return false
    })) {
      videoSourceTmp = this.videoSource.map(item => ({
        ...item,
        isMainWindow: item.videoType === 'main'
      }))
    }
    return videoSourceTmp
  }

  private updateReVideo (reArr: IReplay[]) {
      let videoSourceTmp = this.videoSource.slice()
      reArr.forEach(item => {
      // 偏移量(相对于总时长的开始播放时间)加视屏时长 小于当前播放总时间 并且 当前播放总时间大于偏移量
      // 首先需要判断当前资源的播放时机是否正确，如果不正确，但是他在播放，那就要清除调当前播放的视频
      // console.log(item.offset, item.duration, this.currentPlayTime)
      if (item.offset! + item.duration > this.currentPlayTime && this.currentPlayTime > item.offset!) {
        // 在播放时间内
        if (!this.videoSource.some((source) => source.src === item.src)) {
          videoSourceTmp = videoSourceTmp.concat(item)
        }
      } else {
        videoSourceTmp = videoSourceTmp.filter((source, index) => source.src !== item.src)
        // 不在播放时间内，取消播放
      }
    })
    this.videoSource = videoSourceTmp
  }



}
